module.exports = __webpack_public_path__ + "static/media/s28kz.33e351e3.pdf";